import { FigureGroupData } from "./FigureGroupData";
import { FigureVarSettings, isFigureVarSettings } from "./FigureVarSettings";

export interface FigureTypeSettings {
  value: string;
  label: string;
  properties: FigureVarSettings[];
  dataRowVars: FigureVarSettings[];
  requiredAxis: string[];
  allowedRegressionTypes?: string[];
  defaultNumberOfSeries?: number;
  defaultSeries?: Partial<FigureGroupData>[];
}

/**
 * Type guard to check if an object is a FigureTypeSettings
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureTypeSettings
 */
export const isFigureTypeSettings = (obj: unknown): obj is FigureTypeSettings => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureTypeSettings;
  if (typeof chkObj.value !== "string") {
    return false;
  }
  if (typeof chkObj.label !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((varProp) => !isFigureVarSettings(varProp))) {
    return false;
  }
  if (!Array.isArray(chkObj.dataRowVars)) {
    return false;
  }
  if (chkObj.dataRowVars.some((varProp) => !isFigureVarSettings(varProp))) {
    return false;
  }
  if (!Array.isArray(chkObj.requiredAxis)) {
    return false;
  }
  if (chkObj.requiredAxis.some((name) => typeof name !== "string")) {
    return false;
  }
  if (
    chkObj.allowedRegressionTypes !== undefined &&
    (!Array.isArray(chkObj.allowedRegressionTypes) ||
      chkObj.allowedRegressionTypes.some((type) => typeof type !== "string"))
  ) {
    return false;
  }
  if (
    chkObj.defaultNumberOfSeries !== undefined &&
    (!Number.isFinite(chkObj.defaultNumberOfSeries) ||
      !Number.isInteger(chkObj.defaultNumberOfSeries) ||
      chkObj.defaultNumberOfSeries < 0)
  ) {
    return false;
  }
  if (chkObj.defaultSeries !== undefined && !Array.isArray(chkObj.defaultSeries)) {
    return false;
  }
  return true;
};
